// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item[data-v-299e47be] {\n    margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
